import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';

import { Container } from '../../../../base/Grid';
import Link from '../../../../base/Link';

export const ContainerNavBreadCrumbStyled = styled(Container)`
  ${({ theme }) => {
    const largeDown = theme.largeDown();
    return css`
      &&& {
        /** Enable default container styles */
        position: relative;
        ${largeDown && `top: ${rem(50)}`};
        width: 100%;
        max-width: 90rem; /** 1440px (header max-width) */
        margin: auto;
        padding: 0 0.75rem;
        flex: 0 0 auto;
      }
    `;
  }
}}
`;

export const NavBreadCrumbStyled = styled.nav`
  ${({ theme }) => {
    const large1200Up = theme.large1200Up();
    const xlargeUp = theme.xlargeUp();

    let thisMarginLeft = 0;

    if (xlargeUp) {
      thisMarginLeft = rem(0);
    } else if (large1200Up) {
      thisMarginLeft = rem(18);
    }

    return css`
      display: flex;
      width: 100%;
      height: ${rem(50)};
      ${large1200Up && `margin-left: ${thisMarginLeft}`};
      align-items: center;
      z-index: ${theme.zIndex.globalNavMain};
    `;
  }}
`;

export const NavBreadCrumbListStyled = styled.ol`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const LinkContainerStyled = styled.li`
  ${({ theme, isSecondToLastItem }) => {
    const mediumUp = theme.mediumUp();
    return css`
      display: inline-flex;
      align-items: center;
      /** add separator always desktop */
      ${mediumUp
      && css`
        &:not(:last-child) {
          &::after {
            position: relative;
            padding: 0 ${rem(8)};
            content: '/';
            font-weight: 400;
            color: ${theme.colors.neutral.gray29};
          }
        }
      `};
      /** add separator last 2 */
      ${!mediumUp && !isSecondToLastItem
      && css`
        &:not(:last-child) {
          &::after {
            position: relative;
            padding: 0 ${rem(8)};
            content: '/';
            font-weight: 400;
            color: ${theme.colors.neutral.gray29};
          }
        }
      `};
    `;
  }}
`;

export const LinkStyled = styled(Link)`
  ${({ theme }) => css`
    && {
      height: auto;
      font-size: ${rem(14)};
      line-height: ${rem(16)};
      font-weight: 400;
      color: ${theme.colors.neutral.gray29};
      &:hover {
        color: ${theme.colors.cta.blueHover}; /** TODO: template 3.x.x will be theme.colors.action.lightTheme.linkHover (#005B9C) */
      }
    }
  `}
`;

export const SecondToLastItemStyled = styled.span`
  font-size: ${rem(20)};
`;
